<template>
  <!-- PERSONAL ESIM SECTION  -->
  <div class="section container esim-subscriptions">

    <div class="section-header">
      <div class="section-title">
        <div class="section-icon section-icon-esim" :class="brandClass()"></div>
        <div class="section-title-label">
          {{ $t("profile_no_esim_title") }}
        </div>
        <div
          v-if="!filteredSubscriptions.length && !isActivationFormOpen"
          class="section-subtitle-label"
        >
          {{ $t("profile_no_esim_subtitle_empty") }}
        </div>
        <div
          v-else-if="!filteredSubscriptions.length && isActivationFormOpen"
          class="section-subtitle-label"
        >
          {{ $t("profile_no_esim_subtitle") }}
        </div>
      </div>
    </div>

    <div v-if="!filteredSubscriptions.length" class="no-subscriptions">
      <div v-if="!isActivationFormOpen">
        <div class="infos">
          <div class="buttonsContainer">
            <OneButton
              :brandClass="brandClass()"
              :profileStyle="true"
              :type="'primary'"
              :label="$t('profile_esim_activate_button')"
              @click="openActivationForm"
              :disabled="isSubscriptionMnoTokenInvalidationPending"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <!-- ACTIVATION FORM -->
        <form class="form" @submit.prevent="getRedirect">
          <div class="form_flex_container">
            <div class="custom-field">
              <OneSelect
                :brandClass="brandClass()"
                :t="$t"
                :profileStyle="true"
                :selectLabel="''"
                v-model="form.country"
                :form="v$.form"  
                :paramName="'country'"
                :isSearchEnabled="true"
                :label="$t('profile_esim_activate_selection_country')+'*'"
                :disabled="!countries.length"
                :options="countries"
                @blur="touchForm('country')"
                :errors="[
                  {message:$t('profile_esim_activate_selection_country_error_required'), thereIsTheError:v$.form.country.required.$invalid},
                ]"
              ></OneSelect>
            </div>
            <div class="custom-field">
              <OneSelect
                :brandClass="brandClass()"
                :t="$t"
                :profileStyle="true"
                :selectLabel="''"
                v-model="form.mno"
                :form="v$.form"  
                :paramName="'mno'"
                :label="$t('profile_esim_mno')+'*'"
                :placeholder="$t('profile_esim_active_selection_mno_placeholder')"
                :disabled="!mnos.length"
                :options="mnos"
                @blur="touchForm('mno')"
                :errors="[
                  {message:$t('profile_esim_active_selection_mno_error_required'), thereIsTheError:v$.form.mno.required.$invalid},
                ]"
              ></OneSelect>
            </div>

            <!-- If the user has selected the country and the MNO... -->
            <div
              v-if="form.country && form.mno"
              class="custom-field">

              <!-- If the user has selected any other option besides the Ubigi MNO and the Tata MNO... -->
              <template v-if="!isUbigiId(form.mno) && !isTataId(form.mno)">

                <!-- If the user has at least one phone number registered, show the phone select -->
                <div v-if="this.mobilePhoneList.length" class="custom-field">
                  <OneSelect
                    :brandClass="brandClass()"
                    :profileStyle="true"
                    :selectLabel="''"
                    v-model.trim="form.phone" 
                    :form="v$.form"  
                    :t="$t"
                    :paramName="'phone'"
                    :options="getPhoneNumbers()"
                    @blur="touchForm('phone')"
                    :label="$t('profile_mobile_phone')"
                    :errors="[
                    ]"
                  />
                  <div v-if="this.$c('show_personal_data_section') && this.$c('show_personal_phones')" class="profile-esim-additional-message" :class="brandClass()">{{$t('profile_esim_phone_selection_additional_message_prefix')}}<a tabindex="0" @keydown="ariaClick" @click="$emit('sectionContent','personal_data')">{{$t('profile_menu_personal_data')}}</a>{{$t('profile_esim_phone_selection_additional_message_suffix')}}</div>
                </div>

                <!-- Else, if the show_personal_data_section and the show_personal_phones config params are set to true, show the info message -->
                <div 
                  v-else-if="this.$c('show_personal_data_section') && this.$c('show_personal_phones')" 
                  class="noPhone">
                  <div>
                      <div class="infoContainer">
                        <div class="message_info_icon"></div>
                        <div class="infoText" :class="brandClass()">{{$t('profile_esim_no_phone_available')}}</div>
                      </div>
                  </div>
                  <div>
                      <div class="infoContainer" :class="brandClass()" tabindex="0" @keydown="ariaClick" role="button" @click="$emit('sectionContent','personal_data')">
                        <div class="edit-icon"></div>
                        <div class="enterPhone" @click="$emit('sectionContent','personal_data')">{{$t('profile_enter_phone_number')}}</div>
                      </div>               
                  </div>
                </div>
              </template>

              <!-- Else, show the email input field -->
              <template v-else>
                <div class="custom-field">
                  <OneInput
                    :brandClass="brandClass()"
                    :profileStyle="true"
                    v-model.trim="form.email" 
                    :form="v$.form"     
                    :label="$t('register_page_email_label')" 
                    :paramName="'email'"
                    :id="'email'"
                    @blur="touchForm('email')"
                    :errors="[
                      {message:$t('profile_email_error_required'), thereIsTheError:v$.form.email.required.$invalid},
                      {message:$t('profile_email_error_valid'), thereIsTheError:v$.form.email.email.$invalid},
                      {message:$t('register_page_password_error_not_allowed'), thereIsTheError:v$.form.email.customEmailRegexpValidation.$invalid},
                    ]"
                  />
                  <div 
                    v-if="this.$c('show_personal_data_section') && this.$c('show_personal_phones')" 
                    class="profile-esim-additional-message" 
                    :class="brandClass()"
                    :style="v$.form.email.$errors?.length && 'margin-top: 1rem'">
                    {{$t('profile_esim_phone_selection_additional_message_newdataplan')}}
                  </div>
                </div>
              </template>
            </div>

            <!-- Policy checkbox -->
            <template v-if="esimPolicyDocumentName">
              <div class="consents-container" :class="brandClass()">
                <div class="all-consents">
                  <div class="checkbox-container consents-checkbox-container">

                    <!-- Checkbox -->
                    <OneCheckbox
                      v-model="form.policy_check" 
                      :id="'esim_policy_check'"
                      :form="v$.form"     
                      :paramName="'policy_check'"
                      :brandClass="brandClass()" 
                      :required="!!esimPolicyDocumentName"
                      :labelledBy="'policy-label'"
                      :disabled="isPolicyDocumentLoading"
                      @change="touchForm('policy_check')"
                      @blur="touchForm('policy_check')"
                    />

                    <!-- Label -->
                    <div class="consents-usage-label">
                      <p id="policy-label" class="fallback" :class="[brandClass(), {'invalid':v$.form.policy_check.$dirty && !form.policy_check}]" v-html="policyDocumentBlock?.usageDefinitions?.[0]?.textPrimary + '*'" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="form-info" :class="brandClass()">
            {{ $t("profile_esim_activation_text") }}
          </div>

          <div class="buttonsContainer">
            <OneButton
              :brandClass="brandClass()"
              :profileStyle="true"
              :type="'primary'"
              :label="$t('profile_esim_activate_button')"
              :disabled="isActivateButtonDisabled()"
              @click="getRedirect()"
            />
            <OneButton
              :brandClass="brandClass()"
              :profileStyle="true"
              :type="'secondary'"
              :label="$t('profile_esim_activation_cancel_button')"
              @click="closeActivationForm()"
            />
          </div>
        </form>
      </div>
    </div>
    <div v-else class="subscriptions infos">
      <div
        v-for="(sub, index) of filteredSubscriptions"
        :key="`subscription-${index}`"
        class="subscription-details"
      >
        <div>
          <!-- NETWORK OPERATOR -->
          <div class="info details">
            <div class="label details-label">
              {{ $t("profile_esim_mno") }}
            </div>
            <div class="value details-value">{{ sub.mnoName }}</div>
          </div>
          <!-- PHONE NUMBER -->
          <div v-if="!isUbigiId(sub.mnoId) && !isTataId(sub.mnoId)" class="info details">
            <div class="label details-label">
              {{ $t("profile_esim_summary_phone") }}
            </div>
            <div class="value details-value">
              {{ sub.phoneNumber }}
            </div>
          </div>

        </div>
        <!-- 
          <div class="action-info">
            {{ $t("profile_esim_subscription_disconnection_text") }}
          </div> 
        -->
        <!-- BUTTONS -->
        <div class="buttonsContainer">
          <OneButton
            :brandClass="brandClass()"
            :profileStyle="true"
            :type="'primary'"
            :label="$t('profile_esim_summary_disconnect_button')"
            @click="openUnsubscribePopup()"
          />
        </div>
      </div>
    </div>

    <OneAlert
      :brandClass="brandClass()"
      v-if="isUnsubscribePopUpOpen"
      :title="$t('profile_esim_unsubscribe_popup_title')"
      :content="$t('profile_esim_unsubscribe_popup_subtitle')"
      :button_confirm_label="$t('profile_esim_unsubscribe_popup_confirm_button')"
      :button_cancel_label="$t('profile_esim_unsubscribe_popup_cancel_button')"
      @confirm="unsubscribe"
      @close="closeUnsubscribePopup"
    />
  </div>
</template>

<script>
import { required, requiredIf, email } from "@vuelidate/validators";
import useVuelidate from '@vuelidate/core'
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import OneCheckbox from "../../../../gcdm-one-library/gcdm-one-checkbox/src/OneCheckbox.vue";

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  inject:['$c', '$t', 'brandClass'],
  name: "EsimSubscriptions",
  //validations from vuelidate
  mixins: [oneUtils.customValidationMixin, oneUtils.accessibilityMixin],
    props: {
    user: {},
  },
  components: {
    OneCheckbox
  },
  data: () => ({
    form: {
      country: null,
      mno: null,
      phone: null,
      email: null,
      policy_check: false
    },
    isSubscriptionMnoTokenInvalidationPending:false,
    subscriptions: [],
    filteredSubscriptions: [],
    countries: [],
    mnos: [],
    redirectUrl: "",
    isUnsubscribePopUpOpen: false,
    isActivationFormOpen: false,
    mobilePhoneList: [],
    phoneUtil: null,
    policyDocument: {},
    policyDocumentBlock: {},
    isMounted: false
  }),
  validations: {
    form: {
      country: {
        required: required,
      },
      mno: {
        required: required,
      },
      phone: {
        required: requiredIf(function (model) {
          return (
            !this.isUbigiId(this.form.mno) && 
            !this.isTataId(this.form.mno)
          );
        }),
      },
      email: {
        customEmailRegexpValidation: function (value) {
          return this.customEmailRegexpValidation(value);
        },
        required: requiredIf(function (model) {
          return (
            this.isUbigiId(this.form.mno) || 
            this.isTataId(this.form.mno)
          );
        }),
        email,
      },
      policy_check: {
        required: requiredIf(function (model) {
          return this.esimPolicyDocumentName;
        }),
      }
    },
  },
  computed: {
    esimPolicyDocumentName() {
      return this.$c("_esim_policy_document_name");
    },
    currentCountry() {
      return this.$store.state.configurationParams.country;
    }
  },
  watch: {
    "$store.state.configurationParams": {
      deep: true,
      handler(newVal, oldVal) {
        if(this.esimPolicyDocumentName) {
          if (newVal.language !== oldVal.language) {
            console.log(`[PolicyConsent] language change detected: '${oldVal.language}' -> '${newVal.language}'`);
            if(!this.isPolicyDocumentLoading && this.isMounted) {
              this.configurePolicyConsent();
            }
          }
        }
      },
    },
    "form.country": function (value) {
      this.getMnos(value);
    },
  },
  async mounted() {
    await this.loadPhoneLibrary();
    this.getSubscription();
    this.getCountries();
    this.getMobilePhoneList();

    this.form.email = this.user?.email ?? '';

    if(this.esimPolicyDocumentName) {
      this.getPolicyDocument();
    }
    
    this.isMounted = true;
  },
  methods: {
    isUbigiId(mnoId) {
      return mnoId == "ubibGrSjCx";
    },
    isTataId(mnoId) {
      return mnoId == "taTaCom32";
    },
    getPolicyDocument() {
      this.isPolicyDocumentLoading = true;
      oneUtils.httpClient
        .getPolicyDocument(this.esimPolicyDocumentName)
        .then((res) => {
          this.policyDocument=res;
          this.configurePolicyConsent();
        })
        .catch((err) => {
          this.showError();
        }).finally(() => {
          this.isPolicyDocumentLoading = false;
        });
    },

    configurePolicyConsent() {
      this.policyDocumentBlock = this.policyDocument.textBlocks.find(textBlock => textBlock.language == this.$store.state.configurationParams.language);
    },

    showError() {
      oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
    },

    submitConsent(isDeletingEsim = false, onSuccess) {
      let policyConsent = [{
        consent: isDeletingEsim ? "REJECT" : "ACCEPT",
        consentDate: new Date().toISOString(),
        country: this.policyDocument.country,
        language: this.policyDocumentBlock.language,
        legalEntityId: this.policyDocumentBlock.usageDefinitions[0].legalEntities[0].name,
        majorVersion: this.policyDocument.majorVersion,
        minorVersion: this.policyDocument.minorVersion,
        policyId: this.policyDocument.name,
        purposeId: this.policyDocumentBlock.usageDefinitions[0].purposes[0].purpose.name,
        touchpointId: this.$c("_touchpoint_id"),
        usageId: this.policyDocumentBlock.usageDefinitions[0].usages[0].usage.name
      }];

      oneUtils.httpClient.saveConsents(policyConsent, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
      .then((data) => {
        /* oneUtils.httpClient.getUserInfo(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then((res)=> {
          console.log("[ProfileForm] user refreshed after update policies");

          let lastGivenConsents = res.contactPolicyConsents.filter(consent => 
            consent.policyId == policyConsent.policyId && 
            consent.country == policyConsent.country && 
            consent.majorVersion == policyConsent.majorVersion
          );
          const lastConsentDate = Math.max(...lastGivenConsents.map(c => this.oneMoment.getTimestamp(c.consentDate) ));

          let lastGivenConsent = lastGivenConsents.find(consent => 
            this.oneMoment.getTimestamp(consent.consentDate) == lastConsentDate
          );

          if(lastGivenConsent.consent == policyConsent.consent) {
            onSuccess();
          }
        })
        .catch((err) => {
          oneUtils.trackingUtils.trackTracyError(err.errorPayload);
          console.log("[ProfileForm] error in user refresh after update policies");
        }) */

        onSuccess();
      })
      .catch((err) => {
        this.showError();
      });
    },

    isActivateButtonDisabled() {
      if(this.esimPolicyDocumentName) {
        return (
          this.v$.form.$invalid ||
          this.form.policy_check == false
        )
      }
      else {
        return this.v$.form.$invalid
      }
    },

    /**
     * load google phones librarys 
     */
    async loadPhoneLibrary() {
        this.phoneUtil = await(await import('google-libphonenumber')).PhoneNumberUtil.getInstance();
        this.PNF = await(await import('google-libphonenumber')).PhoneNumberFormat;
    },

    /**
     * This function get the status of the subscriptions
     * and manage the result
     */
    getSubscription() {
      oneUtils.httpClient
        .getCesimSubscription(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then((subscriptions) => {
          // filter subscriptions with mnoTokenStatus AVAILABLE
          this.subscriptions = subscriptions.filter(
            (s) => s.mnoTokenStatus === "AVAILABLE"
          );
          this.isSubscriptionMnoTokenInvalidationPending=false;
          this.isSubscriptionMnoTokenInvalidationPending = subscriptions.some(
            (s) => s.mnoTokenStatus === "INVALIDATION_PENDING"
          );
          if (this.isSubscriptionMnoTokenInvalidationPending) {
            // emit error to show notification
            this.$emit(
              "subscriptionError",
              "MNO_TOKEN_STATUS_INVALIDATION_PENDING"
            );
          }
          // parsing and formatting of phone number
          this.subscriptions = subscriptions.map((sub) => {
            if(sub.phoneNumber){
              const phone = this.phoneUtil.parse((sub.phoneNumber.includes('+') ? sub.phoneNumber : '+'+sub.phoneNumber).replace(/\s/g, ''));
              sub.phoneNumber = this.phoneUtil.format(phone,this.PNF.INTERNATIONAL);
            }
          });

          this.filteredSubscriptions = subscriptions.filter(
            (s) => {
              return s && s.mnoTokenStatus !== "INVALIDATION_PENDING"
            }
          );
        })
        .catch((err) => {
          this.subscriptions = [];
        });
    },

    /**
     * Get the esim country list 
     */
    getCountries() {
      oneUtils.httpClient.getCesimCountries(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(
        (countriesFromService) => {
          // get the list of countries, translates and sorts them
          this.countries = this.$c("list_of_countries")
            .filter((c) => countriesFromService.includes(c.countryKey))
            .map((country) => {
              return {
                value: country.countryKey,
                label: this.$t(country.translationKey),
              };
            })
            .sort((a, b) => {
              //TODO check if still works
              if (a.text < b.text) return -1;
              if (a.text > b.text) return 1;
              return 0;
            });

          // prefill with current value if valid
          const country = this.countries.find(
            (c) => c.value.toLowerCase() === this.currentCountry.toLowerCase()
          );
          // county valorization if present
          if (country) {
            this.form.country = country.value;
          }
        },
        (err) => {
          //error management
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
        }
      );
    },

    /**
     * get mobile phone list
     * and filter the mobile phone
     */

    getMobilePhoneList() {
          if(this.user.communications && this.user.communications.communicationPhones){
              this.mobilePhoneList = this.user.communications.communicationPhones.filter((p)=>{return p.communicationType=='MOB'})
            }
          if(this.mobilePhoneList.length){
              this.form.phone = this.mobilePhoneList[0].value;
              this.touchForm("phone");
            }
    },

    /**
     * get and return the phone value
     */
    getPhoneNumbers(){
      return this.mobilePhoneList.map((p)=>{ 
        const comStatus = p.communicationStatus;
        const phone = 
        this.$t(this.$c("list_of_phoneStatus").filter(
          (type)=>
          type.typeKey==comStatus)[0].translationKey);
        return {
          label : phone +' ('+p.value+')',
          value : p.value
        }; 
      });
    },


    touchForm(fieldName) {
      this.v$.form[fieldName].$touch();
    },


    // Start the activationform and unsubscribe popup view management

    openActivationForm() {
      this.isActivationFormOpen = true;
    },
    closeActivationForm() {
      this.isActivationFormOpen = false;
    },
    openUnsubscribePopup() {
      this.isUnsubscribePopUpOpen = true;
    },
    closeUnsubscribePopup() {
      this.isUnsubscribePopUpOpen = false;
    },

    // End the activationform and unsubscribe popup view management


    /**
     * Unsbuscribe event management
     */
    unsubscribe() {
      oneUtils.httpClient.invalidateCesimSubscription(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(
        (res) => {
          if(this.esimPolicyDocumentName) {
            this.submitConsent(true, () => {
              // update subscriptions
              this.subscriptions = [];
              this.getSubscription();
              // emit unsubscribe
              this.$emit("unsubscribe");
              this.closeUnsubscribePopup();
            });
          }
          else {
            // update subscriptions
            this.subscriptions = [];
            this.getSubscription();
            // emit unsubscribe
            this.$emit("unsubscribe");
            this.closeUnsubscribePopup();
          }
        },
        (err) => {
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
        }
      );
    },

    /**
     * get and return Mnos values filterd and sorted
     */

    getMnos(countryId) {
      if (!countryId) return;
      this.selectedMno = null;
      this.mnos = [];
      this.redirectUrl = null;
      oneUtils.httpClient.getCesimMnos(countryId, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(
        (mnosFromService) => {
          this.mnos = mnosFromService
            .map((mno) => {
              const value = mno.id;

              let label;
              if(this.isUbigiId(mno.id)) {
                label = this.$t("profile_esim_mno_data_only") + "Ubigi";
              }
              else if(this.isTataId(mno.id)) {
                label = this.$t("profile_esim_mno_data_only") + mno.name;
              }
              else {
                label = mno.name;
              }

              return {
                value: value,
                label: label,
              };
            })
            .sort((a, b) => {
              //TODO check if still work
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            });
        },
        (err) => {
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
        }
      );
    },

    /**
     * This function populate the Esim url and redirect to the mno page
     */
    getRedirect() {
      const mnoId = this.v$.form.mno.$model;

      let secretKnowledge = "";

      if(this.isUbigiId(this.form.mno) || this.isTataId(this.form.mno)) {
        secretKnowledge = this.v$.form["email"].$model.substring(
          0,
          4
        );
      }
      else {
        let phone = this.v$.form["phone"].$model.replaceAll(" ", "");
        secretKnowledge = phone.substring(
          phone.length-4, 
          phone.length
        );
      }

      oneUtils.httpClient.getCesimRedirect(mnoId, secretKnowledge, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(
        (res) => {
          const redirect = res;
          const baseUrl = window.location.href.split("?")[0].replaceAll('#/', '');
          const queryParams = Object.assign({}, oneUtils.utils.getQueryParams());
          queryParams["section"] = "esim";
          const queryString = new URLSearchParams(queryParams).toString();
          const redirectUri = baseUrl.concat("?").concat(queryString);
          const separator = redirect.includes("?") ? "&" : "?";

          if(this.isUbigiId(this.form.mno) || this.isTataId(this.form.mno)) {
            this.redirectUrl = redirect
              .replace("$homeMarket", this.user.homeMarket || this.$store.getters.getConfigurationParams.country)
              .replace("$brand", this.$store.getters.getConfigurationParams.brand)
              .concat("&redirect_uri=" + encodeURIComponent(redirectUri));
          }
          else {
            this.redirectUrl = redirect
              .concat(separator)
              .concat("redirect_uri=" + encodeURIComponent(redirectUri))
          }

          if(this.esimPolicyDocumentName) {
            this.submitConsent(false, () => {
              window.location.href = this.redirectUrl;
            });
          }
          else {
            window.location.href = this.redirectUrl;
          }
        },
        (err) => {
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
        }
      );
    },
  },
};
</script>

<style lang="scss">

.section-icon-esim {
  background-image: url('~@/assets/default/light/esim-default-light.svg');
  &.__d{
    background-image: url('~@/assets/default/dark/esim-default-dark.svg');
  }
  &.__rr{
    background-image: url('~@/assets/rr/light/esim-rr-light.svg');
  }
  &.__m{
    background-image: url('~@/assets/mini/light/esim-mini-light.svg');
    &.__d{
      background-image: url('~@/assets/mini/dark/esim-mini-dark.svg');
    }
  }
}
.esim-subscriptions {
  margin-bottom: 30px;

  .section-subtitle-label {
    margin-top: 30px !important;
  }

  .no-subscriptions {
    margin-top: 15px;
  }

  .infos {
    padding-top: 0 !important;
    .subscription-details {
      margin-top: 5px;
      .details,
      .action-info,
      .buttonsContainer {
        margin-top: 25px;
      }
      .vehicles-detail {
        margin-top: 10px;
      }
    }

    .vehicles-detail {
      border: 1px solid $grey6;
      width: 100%;
      min-height: 100px;
      display: flex;
      align-items: center;

      .car-thumbnail {
        width: 150px;
      }
      .subscriptions {
        font-size: 16px;
        font-weight: 400;
        flex-grow: 1;
      }
      .actions {
        font-size: 14px;
        font-weight: 700;
        padding: 5px 24px 5px 5px;
        .action {
          cursor: pointer;
          display: flex;
          align-items: center;
          .arrow {
            background-image: url("~@/assets/default/light/edit-default-light.svg");
            width: 12px;
            height: 20px;
          }
        }
      }
    }
  }
  .form-info {
    margin-top: 30px;

    &.__rr {
      color: rgba(white, 0.6);
      font-family: RivieraNights-Ultralight;
    }
  }

  .noPhone {
    background: #DDE8F9;
    padding: 1rem;
  }
  .message_info_icon{
    background-image: url('~@/assets/default/light/message-info-default-light.svg');
    background-size: contain;
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    padding-right: 3rem;
  }
  .infoContainer {
    display: inline-flex;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .infoText {
    font-size: 16px;
    align-self: center;
      &.__d {
        color: $black;
      }
      &.__rr {
        font-family: RivieraNights-Light;
      }
  }
  .infoContainer {
    &.__rr {
      .enterPhone {
        font-family: RivieraNights-Regular;
      }
    }
  }
  .profile-esim-additional-message {    
    &.__rr {
      font-family: RivieraNights-Ultralight;
      color: rgba(white, 0.6);
    }
  }
  .section-sub-header {
    padding: 0 35px;
  }
  .edit-icon{
    background-image: url('~@/assets/default/light/edit-default-light.svg');
    width: 12px;
    height: 20px;
    padding-right: 15px;
    background-repeat: no-repeat;
  }
  .enterPhone {
    color: $black;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
      &:hover{
        text-decoration-line: underline;
      }
  }

  .checkbox-container {
    flex-wrap: wrap;
    display: flex;
    align-items: baseline;
    padding-top: 0;

    p {
      font-size: 16px;
      margin: 10px;
      margin-left: 15px;

      a{
        color: $black;
        text-decoration: underline;
        font-weight: bold;
      }

      &.__m{
        font-size: 18px;
      }

      &.__t{
        font-family: ToyotaSemibold;
      }

      &.invalid{
        color: $red;
        &.__motorrad{
          color: inherit
        }
      }
    }
  }

  .consents-container{
    .consents-checkbox-container{
      display: flex;

      .consents-usage-label{
        display: inline;
        font-size: 16px;
        line-height: 24px;
      }
    }

    &.__t{
      .consents-checkbox-container{
        font-family: ToyotaSemibold;
      }
    }

    &.__alphabet{
      font-size: 16px;
      font-weight: 500;
      font-family: AlphabetSansPro-Medium;

      .consents-checkbox-container{
        .consents-usage-label{
          color: $alphabetblue;
        }      
      }
    }

    &.__m{
      .consents-checkbox-container{
        font-size: 18px;
        font-family: MINISansSerif;

        .consents-usage-label{
          font-size: 18px;
        }
      }
    }

    &.__rr {
      .consents-checkbox-container{
        font-family: RivieraNights-light;
        color: $grey2;
      }
    }
  }
}
</style>